export default __webpack_public_path__ + "static/media/historic-performace.365c7ec6.png";